<template>
  <b-modal
    ref="modal"
    hide-footer
    title="Xuất Excel phiếu đề nghị mua hàng"
    @hide="onHide"
  >
    <b-row class="mb-3">
      <b-col cols="12">
        <b-form-group label="Danh sách cần xuất:">
          <b-form-radio-group v-model="selectedListExcel" :disabled="isExporting">
            <b-form-radio value="all">Tất cả</b-form-radio>
            <b-form-radio value="filtered">Theo bộ lọc hiện tại</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="text-right mt-2">
      <b-button
        variant="secondary"
        size="sm"
        class="mr-2"
        :disabled="isExporting"
        @click="$refs.modal.hide()"
      >
        <strong>Đóng</strong>
      </b-button>
      <b-overlay
        :show="isExporting"
        rounded
        opacity="0.6"
        class="d-inline-block"
      >
        <template #overlay><b-spinner small></b-spinner></template>
        <b-button variant="info" size="sm" @click="exportExcel">
          <i class="far fa-file-excel"></i> <strong>Xuất Excel</strong>
        </b-button>
      </b-overlay>
    </div>
  </b-modal>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { makeToastSuccess, makeToastFaile, handleError } from '@/utils/common';
import fileDownload from '@/utils/file-download';

const EXPORT_BASE = 'v2/purchase-requests/export';
const POLL_INTERVAL_MS = 1500;
// Khớp PROCESSING_DOWNLOAD_STATUS bên BE.
const STATUS = { PROCESSING: 0, COMPLETED: 1, ERROR: 2 };

export default {
  data() {
    return {
      selectedListExcel: 'all',
      currentFilters: {},
      isExporting: false,
      pollTimer: null,
    };
  },
  beforeDestroy() {
    this.stopPolling();
  },
  methods: {
    open(filters) {
      this.stopPolling();
      this.isExporting = false;
      this.currentFilters = filters || {};
      this.selectedListExcel = 'all';
      this.$refs.modal.show();
    },
    onHide() {
      this.stopPolling();
      this.isExporting = false;
    },
    async exportExcel() {
      if (this.isExporting) return;
      this.isExporting = true;
      try {
        const payload = {
          mode: this.selectedListExcel,
          filters: this.selectedListExcel === 'filtered' ? this.currentFilters : {},
        };
        const { data } = await ApiService.post(EXPORT_BASE, payload);
        if (data.status === 200 && data.data && data.data.id) {
          makeToastSuccess('File đang được tạo, vui lòng chờ trong giây lát!');
          this.startPolling(data.data.id);
        } else {
          this.isExporting = false;
          makeToastFaile(data.message || 'Không tạo được phiên xuất!');
        }
      } catch (error) {
        this.isExporting = false;
        handleError(error);
      }
    },
    startPolling(id) {
      this.stopPolling();
      this.pollTimer = setInterval(() => this.checkProcess(id), POLL_INTERVAL_MS);
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    async checkProcess(id) {
      try {
        const { data } = await ApiService.query(`${EXPORT_BASE}/process`, {
          params: { id, _t: Date.now() },
        });
        const info = data.data || {};
        if (info.processingStatus === STATUS.COMPLETED) {
          this.stopPolling();
          await this.downloadExcel(id);
        } else if (info.processingStatus === STATUS.ERROR) {
          this.stopPolling();
          this.isExporting = false;
          makeToastFaile('Xuất Excel thất bại!');
        }
      } catch (error) {
        this.stopPolling();
        this.isExporting = false;
        handleError(error);
      }
    },
    async downloadExcel(id) {
      try {
        const response = await ApiService.query(`${EXPORT_BASE}/${id}/download`, {
          responseType: 'blob',
        });
        const fileName = fileDownload.getFileName(response);
        fileDownload.createFile(response.data, fileName);
        makeToastSuccess('Xuất Excel thành công!');
        this.$refs.modal.hide();
      } catch (error) {
        handleError(error);
      } finally {
        this.isExporting = false;
      }
    },
  },
};
</script>
